module.exports = __webpack_public_path__ + "img/04.c92076e0.png";